import React, { useEffect } from 'react';
import './Toast.css';

const Toast = ({ message, type, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 3000); // Убираем плашку через 3 секунды

        return () => clearTimeout(timer); // Очищаем таймер при размонтировании
    }, [onClose]);

    // Центрируем только сообщения об успехе
    const classes = `toast toast--${type} ${type === 'success' ? 'toast--center' : ''}`;

    return (
         <div className={classes}>
                    <span>{message}</span>
                    <button onClick={onClose} className="toast__close-button">&times;</button>
                </div>
    );
};

export default Toast;
